<template>
  <li :style="itemStyle" @click="handleSelectBg">
    <div :style="currentBoxStyle" v-if="props.type === 'image'" class="image-item-box">
      <div class="loading-box">
      </div>
      <!-- <a-image :src="imageItem.url" :style="imageStyle" :fallback="errorImageUrl" v-if="loading" /> -->
      <img :src="imageItem.url" crossorigin="anonymous" :style="imageStyle" v-if="imageItem.url"
        class="cursor-item box-index" />
    </div>
    <div :style="currentBoxStyle" v-else class="image-item-box">
      <div :style="colorStyle" class="cursor-item">
      </div>
    </div>
  </li>

</template>
<script setup>
import { ref, defineProps, defineEmits, computed, watchEffect } from 'vue'
import iconOpacity from '@/assets/common-icons/icon_opacity.png'
const props = defineProps({
  imageWidth: {
    type: String,
    default: '76px'
  },
  imageHeight: {
    type: String,
    default: '76px'
  },
  imageItem: Object,
  customStyle: Object,
  type: String,
  border: Boolean,
  borderRadius: String,
  currentShowBgItem: Object,
  boxWidth: {
    type: String,
    default: '76px'
  },
  showBoxBorder: Boolean,
  loading: Boolean
})


const errorImageUrl = ref('data:image/png;base64,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')
const getImageUrl = (url) => {
  return new Promise((resolve, reject) => {
    const image = new Image()

    image.onload = function () { // 图片地址有效
      resolve(image)
    }
    image.onerror = function () { // 图片加载失败
      reject('could not load image')
    }
    image.src = url
  })
}



const currentBoxStyle = computed(() => {
  if (props.currentShowBgItem?.id === props.imageItem?.id) {
    return {
      width: props.boxWidth,
      height: props.boxWidth,
      border: props.showBoxBorder ? '3px solid rgb(99, 44, 255)' : '3px solid rgb(255, 255, 255)',
      'border-radius': '7px'
    }
  } else {
    return {
      width: props.boxWidth,
      height: props.boxWidth,
      border: props.showBoxBorder ? '3px solid #fff' : '',
      'border-radius': '4.14545px'
    }
  }
})
const imageStyle = computed(() => {
  return {
    width: props.imageWidth,
    height: props.imageWidth,
    'border-radius': props.borderRadius || '4.14545px',
  }
})

const colorStyle = computed(() => {
  return {
    width: props.imageWidth,
    height: props.imageWidth,
    'border-radius': props.borderRadius || '4.14545px',
    background: props.imageItem.color,
    border: props.border ? '0.5px solid #D0D0D0' : ''
  }
})

const itemStyle = computed(() => {
  const style = {
    // width: props.imageWidth,
    // height: props.imageWidth,
    backgroundColor: props.backgroundColor,
    // borderRadius: props.borderRadius,
  }
  return {
    ...style,
    ...props.customStyle
  }
})
const emits = defineEmits(['click'])

const handleSelectBg = () => {
  emits('click')
};



</script>
<style lang="less" scoped>
.cursor-item {
  cursor: pointer;
}

.box-index {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.image-item-box {
  box-sizing: content-box;
  // position: relative;
  background-color: #efefef;
  position: relative;
}


.loading-box {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-color: #EDEDED;
  animation: skeleton-loading 1.4s ease infinite;
}

@keyframes skeleton-loading {
  0% {
    background-color: #dddada;
    opacity: 1;
  }

  30% {
    background-color: #dddada;
    opacity: 0.5;
  }


  50% {
    background-color: #dddada;
    opacity: 0.8;
  }

  70% {
    background-color: #dddada;
    opacity: 0.5;
  }



  100% {
    background-color: #dddada;
    opacity: 1;
  }


  // 70% {
  //   opacity: 0.6;
  // }

  // 85% {
  //   opacity: 0.5;
  // }

  // 100% {
  //   opacity: 0.3;
  // }
}
</style>